require.register("app/supplier/stat/OrderCountView", function(exports, require, module){
  $0
  
});

